module.exports = __webpack_public_path__ + "img/asian-thick-noodles-1.f0cbe5d4.jpg";